import { render, staticRenderFns } from "./ProductContainerHeader.vue?vue&type=template&id=67f995d6&scoped=true&"
import script from "./ProductContainerHeader.vue?vue&type=script&lang=js&"
export * from "./ProductContainerHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProductContainerHeader.vue?vue&type=style&index=0&id=67f995d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f995d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VContainer,VRow,VSelect,VSpacer,VTextField})
